/** AppKit 关窗会删 w3m-modal，但模块 isInitialized 不会再 inject；仅在没有宿主时补 DOM */
export async function ensureW3mModalHost() {
  if (typeof document === 'undefined') return
  if (document.querySelector('w3m-modal, appkit-modal')) return
  await import('@reown/appkit-scaffold-ui/basic')
  await import('@reown/appkit-scaffold-ui/w3m-modal')
  if (!document.querySelector('w3m-modal, appkit-modal')) {
    const el = document.createElement('w3m-modal')
    document.body.insertAdjacentElement('beforeend', el)
  }
}

/** @deprecated 桌面 WC 走 Rosswap activate */
export async function ensureProviderAppKitModal(provider) {
  if (!provider?.rpc?.showQrModal) return
  await ensureW3mModalHost()
}
